import { Module } from '@fwk-node-modules/vuex';

export const types = {
  getters : {
    GET_USER_MODULES : 'GET_USER_MODULES',
    GET_USER_SELECTED_MODULE : 'GET_USER_SELECTED_MODULE',
    GET_USER_FILES : 'GET_USER_FILES',
    GET_GENERATE_REPORT_PROCESSES : 'GET_GENERATE_REPORT_PROCESSES'
  },
  mutations : {
    SET_USER_MODULES : 'SET_USER_MODULES',
    SET_USER_SELECTED_MODULE : 'SET_USER_SELECTED_MODULE',
    SET_USER_FILES : 'SET_USER_FILES',
    SET_GENERATE_REPORT_PROCESSES : 'SET_GENERATE_REPORT_PROCESSES'
  },
  actions : {
    
  }
}

export function createVatValidationStore () {

  const vatValidationStore:Module<any, any> = {
    namespaced: true,
    state: {
      userModules : [], // We store the modules associated to the user on the target DB.
      userSelectedModule : null, // We store the production module associated to the user on the target DB.
      userFiles : [], // We store the module associated files
      generateReportProcesses: [] // We store the generate report processes
    },
    getters: {
      // List of admin elements
      [types.getters.GET_USER_MODULES] (state):any { return state.userModules; },
      [types.getters.GET_USER_FILES] (state):any { return state.userFiles; },
      [types.getters.GET_GENERATE_REPORT_PROCESSES] (state):any { return state.generateReportProcesses; },

      // Selected admin element
      [types.getters.GET_USER_SELECTED_MODULE] (state):any { return state.userSelectedModule; }
    },
    mutations: {
      [types.mutations.SET_USER_MODULES] (state, modules) { state.userModules = modules; },
      [types.mutations.SET_USER_SELECTED_MODULE] (state, module) { state.userSelectedModule = module; },
      [types.mutations.SET_USER_FILES] (state, files) { state.userFiles = files; },
      [types.mutations.SET_GENERATE_REPORT_PROCESSES] (state, processes) { state.generateReportProcesses = processes; }
    },
    actions: {
    }
    
  }
  return vatValidationStore;
};